module.exports = __webpack_public_path__ + "static/img/manual-30.71a910b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-30.png
// module id = IASs
// module chunks = 4